import React from "react";
import Company from "../../types/Company";
import {
  Select,
  MenuItem,
  Container,
  InputLabel,
  FormControl,
  OutlinedInput,
  Button
} from "@material-ui/core";
import { Api } from "../../api";
import { useSnackbar } from "notistack";
import { hasError } from "../../helpers/ResponseHelper";

export default function AdminSeedDefaults() {
  const [companies, setCompanies] = React.useState<Array<Company>>([]);
  const [companyId, setCompanyId] = React.useState<string>("");
  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    Api.companies.getCompaniesByEmployee().then(result => {
      let resultData: Company[] = result.data.data;
      if (resultData) {
        setCompanies(resultData);
        if (resultData.length > 0) {
          setCompanyId(resultData[0].companyId);
        }
      }
    });
  }, [enqueueSnackbar]);

  function seedDocumentCategories() {
    if (companyId)
      Api.documents.seedDefaultCategories(companyId).then(response => {
        if (!hasError(response)) {
          enqueueSnackbar("Seed successful", { variant: "success" });
        }
      });
  }

  function seedTrainingCategories() {
    if (companyId)
      Api.trainingCategory.seedDefaultCategories(companyId).then(response => {
        if (!hasError(response)) {
          enqueueSnackbar("Seed successful", { variant: "success" });
        }
      });
  }

  return (
    <Container maxWidth="md">
      <FormControl fullWidth variant="outlined" margin="normal">
        <InputLabel>Company</InputLabel>
        <Select
          value={companyId}
          onChange={(e: React.ChangeEvent<any>) => setCompanyId(e.target.value)}
          input={<OutlinedInput labelWidth={60} name="type" id="type" />}
        >
          {companies.map(company => (
            <MenuItem value={company.companyId} key={company.companyId}>
              {company.companyName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        variant="contained"
        fullWidth
        style={{ marginTop: 20 }}
        onClick={seedDocumentCategories}
      >
        Seed Document Categories
      </Button>
      <Button
        variant="contained"
        fullWidth
        style={{ marginTop: 20 }}
        onClick={seedTrainingCategories}
      >
        Seed Training Categories
      </Button>
    </Container>
  );
}
